import React from 'react'
// @ts-ignore no types
import config from '@adc/configment'
// @ts-ignore no types
import { useApplicationSurvey } from '@adc/ui-adc'
import { useListingContext } from '../../context/listing'
import Gallery from '../../components/propertyGallery'

interface PropertyGalleryProps {
  featureFlags: any
}
const PropertyGallery = ({ featureFlags }: PropertyGalleryProps) => {
  const { listing } = useListingContext()
  const images = listing?.photos?.map(imageObject => {
    return imageObject?.file_descriptor.urls?.cdn || []
  })
  // eslint disables here since useApplicationSurvey response not typed yet
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const { manageSurveyVisibility } = useApplicationSurvey()

  const coords = {
    lat: listing?.primary_property?.summary?.address.coordinates?.lat,
    lng: listing?.primary_property?.summary?.address.coordinates?.lon,
  }

  return (
    <Gallery
      config={{
        GOOGLE_MAP_CLIENT_ID: config.get('GOOGLE_MAP_CLIENT_ID'),
        GOOGLE_MAP_CHANNEL: config.get('GOOGLE_MAP_CHANNEL'),
      }}
      coords={coords}
      statusLabel={listing.listing_status_label}
      images={images}
      addressTuple={listing.formatted_address}
      featureFlags={featureFlags}
      listing={listing}
      manageSurveyVisibility={manageSurveyVisibility}
    />
  )
}

export default PropertyGallery
